module.exports = __webpack_public_path__ + "img/vip.fd25e9b7.svg";